module.exports = __webpack_public_path__ + "static/img/icon-2.dc1e43b8.png";